module.exports = __webpack_public_path__ + "img/step2.78f35676.svg";